let toSubName = value => {
    if (!!value) {
        return value.substr(-1,1)
    }
};
let firstName = value => {
    if (!!value) {
        return value.substr(0,1).toLocaleUpperCase()
    }
};
let toDays = value => {
    if(value < 0) {
        return '生日已过'
    }else if (value === 0) {
        return '今天'
    }else if (value === 1) {
        return '明天'
    }else if (value === 2) {
        return '后天'
    } else {
        return value+'天'
    }
};
let userDepartment = value => {
    if (!!value) {
        return typeof value == 'string' ? value : value[0].substr(0,8)
    }
};
let toDate = (value,type) => {
    let arr = value.split('-')
    if (type === 'month') {
        return arr[0]
    }else if (type === 'day') {
        return arr[1]
    }
};
let toMonAndDay = (value) => {
    let arr = value.split('-')
    return arr[1]+'月'+arr[2]+'日'  //    继续做这里
}
let toDate2 = (value) => {
    console.log('todate2-value',value)
    let date = new Date (value)
    console.log('todate2-date',date)
    let year = date.getFullYear()
    let month = (date.getMonth()+1).toString().length >1 ? date.getMonth()+1 : '0'+(date.getMonth()+1)
    let day = date.getDate().toString().length >1 ? date.getDate() : '0' + date.getDate()
    return year+'.'+month+'.'+day
}
export {firstName, toSubName ,toDays, userDepartment, toDate, toMonAndDay ,toDate2}